

export const getCurrentDate = () => {
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Month is zero-based, so add 1
  const day = String(currentDate.getDate()).padStart(2, '0');
  return `${year}_${month}_${day}`;
}

export const  getCurrentDateMysql = () => {
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Month is zero-based, so add 1
  const day = String(currentDate.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export const  getCurrentDateYmd= () => {
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Month is zero-based, so add 1
  const day = String(currentDate.getDate()).padStart(2, '0');
  return `${year}${month}${day}`;
}

export const  getCurrentDateTimeMysql= () => {
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Month is zero-based, so add 1
  const day = String(currentDate.getDate()).padStart(2, '0');
  const hours = String(currentDate.getHours()).padStart(2, '0');
  const minutes = String(currentDate.getMinutes()).padStart(2, '0');
  const seconds = String(currentDate.getSeconds()).padStart(2, '0');
  const date = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  ;
  return date;
}

export const  getDateTimeMysqlFormat= (DateTimeStamp) => { 
  const currentDate = DateTimeStamp ? new Date(DateTimeStamp) : new Date();
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Month is zero-based, so add 1
  const day = String(currentDate.getDate()).padStart(2, '0');
  const hours = String(currentDate.getHours()).padStart(2, '0');
  const minutes = String(currentDate.getMinutes()).padStart(2, '0');
  const seconds = String(currentDate.getSeconds()).padStart(2, '0');
  const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  return formattedDate;
}


export const  getDateTimeMysqlGivenFormatYmdhi= (DateTimeStamp) => { 
  const currentDate = DateTimeStamp ? new Date(DateTimeStamp) : new Date();
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Month is zero-based, so add 1
  const day = String(currentDate.getDate()).padStart(2, '0');
  const hours = String(currentDate.getHours()).padStart(2, '0');
  const minutes = String(currentDate.getMinutes()).padStart(2, '0');
  const seconds = String(currentDate.getSeconds()).padStart(2, '0');
  const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}`;
  return formattedDate;
}


export const  getDateTimeMysqlGivenFormatYmd= (DateTimeStamp) => { 
  const currentDate = DateTimeStamp ? new Date(DateTimeStamp) : new Date();
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Month is zero-based, so add 1
  const day = String(currentDate.getDate()).padStart(2, '0');
  const hours = String(currentDate.getHours()).padStart(2, '0');
  const minutes = String(currentDate.getMinutes()).padStart(2, '0');
  const seconds = String(currentDate.getSeconds()).padStart(2, '0');
  const formattedDate = `${year}-${month}-${day}`;
  return formattedDate;
}

export const getDisplayDateTimeFormat = (DateTimeStamp) => { 
  const currentDate = DateTimeStamp ? new Date(DateTimeStamp) : new Date();
  // Validate date
  if (isNaN(currentDate)) {
    throw new Error('Invalid Date');
  }
  const year = currentDate.getFullYear();
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const month = monthNames[currentDate.getMonth()]; // Get month name from the array
  const day = String(currentDate.getDate()).padStart(2, '0');
  const hours = String(currentDate.getHours()).padStart(2, '0');
  const minutes = String(currentDate.getMinutes()).padStart(2, '0');
  const second = String(currentDate.getSeconds()).padStart(2, '0');
  
  return `${day} ${month} ${year} ${hours}:${minutes}:${second}`;
}

export const encodeIdToBase64 = (id) => {
  const bytes = new Uint8Array(7);
  for (let i = 0; i < 6; i++) {
    bytes[6 - i] = id & 0xFF;
    id = id >> 8;
  }
  const binary = String.fromCharCode(...bytes);
  return btoa(binary).slice(0, 10);
};

export const decodeBase64ToId = (encoded) => {
  const binary = atob(encoded + '==');
  const bytes = new Uint8Array([...binary].map(char => char.charCodeAt(0)));
  let id = 0;
  for (let i = 1; i < 7; i++) {
    id = (id << 8) + bytes[i];
  }
  return id;
};
